import React from 'react';

import { Helmet } from 'react-helmet';

import { Alert, Box, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';
import PermissionedComponent from '~/components/Common/PermissionedComponent';

import { ROLE_ADMIN_USER } from '~/consts/roles';

import CsDashboardContent from './CsDashboardContent';

export default function CsDashboardPage() {
  return (
    <Container>
      <Helmet>
        <title>Agent Actions Dashboard | Admin</title>
      </Helmet>

      <PageHeader title="Agent Actions Dashboard" />

      <PermissionedComponent
        requiredRoles={[ROLE_ADMIN_USER]}
        fallback={
          <Box mt={4}>
            <Alert severity="error">You don't have permission to view this page.</Alert>
          </Box>
        }
      >
        <CsDashboardContent />
      </PermissionedComponent>
    </Container>
  );
}
